import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { Delete, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import { useGetSubscribersQuery } from "./api/newsletterApi";
import { Subscriber } from "./types/subscribers";
import AddEditNewsletterDialog from "./components/AddNewsletter";

const SubscribersManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

//   const [openConfirmModal, setOpenConfirmModal] = useState(false);
//   const [selectedSubscriber, setSelectedSubscriber] = useState<Subscriber | null>(null);
  const navigate = useNavigate();
  const [openNewsletterDialog, setOpenNewsletterDialog] = useState(false);

  const { data: subscribers, isLoading, isError, isFetching } = useGetSubscribersQuery();

  const columns: Array<MRT_ColumnDef<Subscriber>> = [
    {
      header: "Email",
      accessorKey: "email",
      size: 200,
    },
    {
      header: "Subscribed At",
      accessorKey: "subscribed_at",
      size: 180,
      Cell: ({ cell }) => (
        <Typography>
          {new Date(cell.getValue<string>()).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          }).replace(',', '/')}
        </Typography>
      ),
    },
  ];

  return (
    <Box>
      <DataTable<Subscriber>
        toolbar={
            <Box display="flex" alignItems="center" width="100%">
              <Box display="flex" gap={3} alignItems="center" flex="1">
                <Typography variant="h6">Subscribers</Typography>
                <Chip
                  color="primary"
                  variant="outlined"
                  label={`${subscribers?.data?.length ?? 0} Subscribers`}
                />
              </Box>
          
              {/* <Box display="flex" gap={2}>
                <Button
                  onClick={() => setOpenNewsletterDialog(true)}
                  variant="outlined"
                >
                  Send Newsletter
                </Button>
          
             
              </Box> */}
            </Box>
          }
          
        list={subscribers?.data ?? []}
        count={subscribers?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        pagination={pagination}
        onPaginationChange={setPagination}
      />
    </Box>
  );
};

export default SubscribersManager;
